import 'url-search-params-polyfill'
import 'intersection-observer'

if (typeof window !== 'undefined' && typeof window.Proxy === 'undefined') {
  window.Proxy = function () {}
  window.ProxyPolyfilled = true
} else {
  window.ProxyPolyfilled = false
}
